import { Component, Input, OnInit } from '@angular/core';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { LinkModel } from '../../../../Common/Forms/models/link.model';
import { LinkListStateEnum } from '../../enums/link-list-state.enum';

@Component({
    selector: 'agpr-link-list',
    templateUrl: './link-list.component.html',
    styleUrls: ['./link-list.component.scss'],
    standalone: false
})
export class LinkListComponent {
    @Input() set links (links: LinkModel[]) {
        if (!links) {
            this._links = [];
        } else {
            this._links = links;
        }
        this.setState();
    }
    @Input() set showList(showList: boolean) {
        this._showList = showList;
        this.setState();
    }
    @Input() id: string;
    @Input() itemsMessage: string = 'Common.linkList.items';
    @Input() listAriaLabel: string;

    _links: LinkModel[];
    _showList = false;

    state: LinkListStateEnum;
    linkListStateEnum = LinkListStateEnum;

    readonly buttonTypes = ButtonTypesEnum;

    constructor() {}

    /**
     * Sets the state of the link list
     */
    setState() {
        if (this._links.length === 1) {
            this.state = LinkListStateEnum.SHOW_FIRST;
        } else if (this._links.length > 1 && !this._showList) {
            this.state = LinkListStateEnum.HIDDEN;
        } else if (this._links.length > 1 && this._showList) {
            this.state = LinkListStateEnum.SHOW_ALL;
        }
    }

    /**
     * Toggles the list from showing all or hiding
     */
    toggleList() {
        this._showList = !this._showList;
        this.setState();
    }

    /**
     * Opens new tab/window to the link url
     */
    linkClick(link: LinkModel) {
        window.open(link.url);
    }
}
